module.exports = __webpack_public_path__ + "img/devapp.39fca130.png";